import React, { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { useMst } from '../../../../internal';
import { InputField } from '../../../../components/UI/input/InputField';
import { StandardDurationPick } from '../../../../components/domain/duration/StandardDurationPick';
import { BannerDurationModal } from '../components/BannerDurationModal';
import { Button } from '../../../../components/UI/buttons/regular/Button';
import { CheckboxGroup } from '../../../../components/UI/checkbox/CheckboxGroup';
import arrowBack from '../../../../assets/icons/arrow-back.svg';
import { ConfirmationModal } from '../../../../components/UI/confirmation-modal/ConfirmationModal';
import styles from './../Banners.module.scss';

export const CreateNewsletterPage = observer((): ReactElement => {
  const { t } = useTranslation();
  const mst = useMst();
  const {
    currentPage,
    router: { queryParams },
  } = mst;
  const { type, id } = queryParams;

  return (
    <div className={styles.PageContainer}>
      <div
        className={styles.NavigateBack}
        onClick={() => {
          currentPage.navigateToBannersPage(type);
        }}
      >
        <img className={styles.Arrow} src={arrowBack} alt={'arrow right'} />
        <span>{t('banners:back_to_banners')}</span>
      </div>
      <div className={styles.PageTitleContainer}>
        <div className={styles.PageTitle}>
          {t(id ? 'basic:edit_newsletter' : 'basic:create_newsletter')}
        </div>
      </div>
      <div className={styles.AdListOuterContainer}>
        <div className={styles.InputFieldContainer}>
          <InputField model={currentPage.getName()} />
        </div>
        <div className={styles.CheckboxContainer}>
          <CheckboxGroup model={currentPage.getCheckboxGroup()} />
        </div>
        <div className={styles.InputFieldContainer}>
          <InputField model={currentPage.getUrl()} />
        </div>
        <div>
          <iframe
            src={currentPage.getUrl().value}
            width="365"
            height="600"
          ></iframe>
        </div>
        <div className={styles.InputFieldContainer}>
          <StandardDurationPick
            model={currentPage.getNewsletterDuration()}
            label={t('banners:pick_dates_intro')}
          >
            <BannerDurationModal model={currentPage.getNewsletterDuration()} />
          </StandardDurationPick>
        </div>
        <Button onClick={currentPage.submitData}>{t('banners:save')}</Button>
        {id && (
          <p
            onClick={currentPage.openConfirmationModal}
            className={styles.DeleteBanner}
          >
            {t('banners:delete_banner')}
          </p>
        )}
      </div>
      <ConfirmationModal model={currentPage.getConfirmationModal()}>
        <>
          <div>
            <strong>{t('banners:delete_title')}</strong>
          </div>
          <div>{t('banners:delete_confirmation')}</div>
        </>
      </ConfirmationModal>
    </div>
  );
});
